import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import '@/assets/main.less';
import _ from 'lodash';


Vue.config.productionTip = false
Vue.use("_");

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')